import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("am_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const publicApi = {
  barbers: () => api.get("/barbers").then((r) => r.data),
  services: () => api.get("/services").then((r) => r.data),
  settings: () => api.get("/settings").then((r) => r.data),
  availability: (barber_id, date) =>
    api.get("/availability", { params: { barber_id, date } }).then((r) => r.data),
  createAppointment: (payload) => api.post("/appointments", payload).then((r) => r.data),
};

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "Something went wrong";
}
